import React from "react";
import { Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
// import { LeftArrow } from '../../components/SVGComponents/arrow';
import "./TermsAndCondition.scss";
import { path } from '../../constants';
import { KLogo, MainLogo } from "../../assets/svg";


const TermsAndCondition = () => {
  const navigate = useNavigate()
  const handleRedirect = () => {
    navigate(-1)
  }

  const userId = localStorage.getItem('userID')

  return (
    <div>
      <div className="w-100 d-flex justify-content-center">
        <div className="d-flex justify-content-between p-3 w-75">
          <Image
            width={280}
            src={MainLogo}
            alt="company logo"
            className="logo-container"
            onClick={handleRedirect}
            fluid={true}
          />
         </div>
      </div>
      <div className='terms-conditions-container'>
        <div className='title-container'>
          <div className='back-button'>
           
          </div>
          <div className='divider' />
          <span className='title'>KALP STUDIO TERMS AND CONDITIONS OF USE</span>
        </div>

        <div className='description-main-container'>
          <span className='main-description'>
            This ‘KALP STUDIO PLATFORM- Terms and Conditions of Use’, contains
            terms and conditions (“Platform Terms”) that constitute a legally
            binding agreement by and between MUNEEMJI CONNECTIONS PRIVATE LIMITED,
            a private limited company incorporated under the Companies Act of
            India 2013, (“Company “or “we”) and each end user (which includes a
            visitor/surfer) (“You”, “you” or “user”) of the comprehensive platform
            of the Company that empowers developers to create and extend
            decentralized applications Kalp Studio (“Platform”) available at
            https:/kalp/studio or such other URL (“Site”) as may be designated by
            the Company from time to time.
          </span>
          <span className='main-description-title'>
            THESE PLATFORM TERMS CONSTITUTE A LEGAL AGREEMENT BETWEEN YOU AND THE
            MUNEEMJI CONNECTIONS PRIVATE LIMITED. <br />
            <br />
            BY SUBMITTING A REQUEST TO CREATE, STREAMLINE PROJECT, DISPLAY, VIEW,
            ACCESS ANY PLATFORM FEATURE, YOU ARE DEEMED TO HAVE READ, ACCEPTED,
            EXECUTED AND AGREED TO BE BOUND BY THESE PLATFORM TERMS AND THE OTHER
            TERMS INCORPORATED HEREIN BY REFERENCE. IF YOU DO NOT AGREE TO ANY
            PROVISION OF THIS PLATFORM TERMS, YOU SHALL NOT USE/ACCESS THE KALP
            STUDIO IN ANY MANNER.
          </span>
          <div className='description-container'>
            <span className='description-title'>1. KALP STUDIO</span>
            <div className='sub-description-container'>
              <span className='sub-description-number'>1.1</span>
              <span className='sub-description'>
                The Company created a robust and comprehensive Platform, enabling
                users to streamline project management, enhance transparency and
                provide capability to independently deploy and manage smart
                contracts within the confines of the Company’s public permissioned
                blockchain. (“Kalp DLT”).
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>1.2</span>
              <span className='sub-description'>
                The Company’s Platform has been made available solely for the
                people who have registered on the Site as users by satisfying the
                eligibility criteria detailed under Clause 2 and completing the
                On-Boarding KYC Process (“Registered Users”). A visitor or surfer
                of the Site being an unregistered user shall also comply with all
                the applicable provisions of this Site’s policy which primarily
                includes but is not limited to the eligibility criteria detailed
                under Clause 2.
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>1.3</span>
              <span className='sub-description'>
                Kalp Studio is not a payment gateway, wallet provider, broker,
                financial institution or creditor. The Company has engaged certain
                third-party payment gateways or aggregators (“PG”) to facilitate
                payment between the users and the Company. Such payments shall be
                governed by the policies and terms and conditions of the
                authorized PG which we deem that you have consented to. If you
                have any issues related to payments, please contact the PG
                directly.
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>1.4</span>
              <span className='sub-description'>
                The Company is proud to unveil Kalp Studio, an intuitive user
                interface meticulously developed to accommodate a diverse range of
                skill levels, from aspiring enthusiasts to individual
                professionals and entities. This innovative platform is designed
                to streamline access to blockchain technology and simplify the
                process of deploying smart contracts within a well-organized
                framework. Kalp Studio offers a comprehensive suite of services to
                its users, including developer onboarding, smart contract
                management, project management, and the generation of API
                endpoints and authentication keys (“Services”), all aimed at
                providing a user-friendly experience.
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>1.5</span>
              <span className='sub-description'>
                The Company shall not allow any unregistered user to post, sell,
                rent, lease, transfer, distribute, buy, create, sell, access, any
                features on the Kalp Studio.
              </span>
            </div>
          </div>
          <div className='description-container '>
            <span className='description-title'>2. ELIGIBILITY CRITERIA</span>
            <div className='sub-description-container column'>
              <div>
                <span className='sub-description-number'>2.1</span>
                <span className='sub-description'>
                  By accessing the Kalp Studio, you agree and warrant that:
                </span>
              </div>
              <div className='key-value-container'>
                <div className='key-value'>
                  <span className='roman-number'>(i)</span>
                  <span className='text'>You are at least 18 years old;</span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(ii)</span>
                  <span className='text'>
                    You are capable of entering and authorized to enter into a
                    legally binding agreement;
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(iii)</span>
                  <span className='text'>
                    All information that you share on the Kalp Studio or provide
                    to us is true and accurate;
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(iv)</span>
                  <span className='text'>
                    You have the authority and capability to enter into this
                    Agreement abiding by all the provisions of these Platform
                    Terms;
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(v)</span>
                  <span className='text'>
                    You are not impersonating any person or entity;
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(vi)</span>
                  <span className='text'>
                    You are not subject to any financial sanctions, embargoes or
                    other restrictive measures imposed by the UK Treasury, US
                    Office of Foreign Assets Control (OFAC), United Nations
                    Security Council, European Union, any EU country. or any
                    governmental or inter country authority (“Sanctions”);
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(vii)</span>
                  <span className='text'>
                    You are not currently suspended or banned by the Company from
                    accessing the Kalp Studio;
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(viii)</span>
                  <span className='text'>
                    You are not a politically exposed person;
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(x)</span>
                  <span className='text'>
                    The jurisdiction in which you are situated does not prohibit
                    you from using the platforms such as this Kalp Studio
                  </span>
                </div>
              </div>
            </div>

            <div className='sub-description-container'>
              <span className='sub-description-number'>2.2</span>
              <span className='sub-description'>
                Kindly note that if a user is an entity and not an individual,
                such user warrants that it, as an entity and all the stakeholders
                (shareholders, directors, ultimate beneficial owners) in their
                individual capacity are eligible to access the Kalp Studio based
                on the above-mentioned criteria and the individual accessing the
                Kalp Studio on behalf of an entity is authorized to do so by the
                entity who is the ultimate user.
              </span>
            </div>
          </div>
          <div className='description-container'>
            <span className='description-title'>
              3. REGISTERED USER’S ACCOUNT
            </span>
            <div className='sub-description-container'>
              <span className='sub-description-number'>3.1</span>
              <span className='sub-description'>
                In order to use features on Kalp Studio, an account of user shall
                be created on the Kalp Studio Site for every Registered User after
                successfully completing all the On-Boarding KYC Process
                (“Account”).
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>3.2</span>
              <span className='sub-description'>
                By registering on the Site you understand that the Company
                reserves the right, in its sole discretion, to deny you access to
                this Platform or any portion thereof without notice for the
                following reasons (a) any unauthorized access or use by you; (b)
                if you violate any provision of the Company’s policies which
                includes this Platform Terms, Privacy Policy, or any other policy
                enacted and posted by the Company from time to time; (c) a
                direction from any governmental authority; (d) if the Company is
                of the opinion that your Account is being used for immoral or
                unlawful purposes or the financial transaction being made through
                your Account are suspicious; or (e) you fail to adequately
                response to the Company’s intimations or queries raised with
                respect to your Account.
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>3.3</span>
              <span className='sub-description'>
                If you feel the security of your Account has been compromised or
                any unauthorized or suspected unauthorized use of your Account,
                you shall immediately report it to us at care@kalp.studio. The
                Company bears no responsibility or liability for any unauthorized
                access or use of the Account or any loss or damage arising out of,
                or in relation to such unauthorized access or use.
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>3.4</span>
              <span className='sub-description'>
                Take a notice of in the event a user&apos;s Account is deleted
                from the Site, all data related to the user will be removed.
                However, it is important to acknowledge that information on the
                Kalp DLT cannot be deleted.
              </span>
            </div>
          </div>
          <div className='description-container'>
            <span className='description-title'>4. PAYMENT</span>
            <div className='sub-description-container'>
              <span className='sub-description-number'>4.1</span>
              <span className='sub-description'>
                The user is obligated to remit the fee for the Services provided
                by Kalp Studio (“Subscription Fee”). The Subscription Fee is
                non-refundable under any circumstances.
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>4.2</span>
              <span className='sub-description'>
                The Company will impose a transaction fee for every API request
                and each smart contract uploaded Kalp Studio. (“Transaction Fee”).
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>4.3</span>
              <span className='sub-description'>
                After the subscription period expires, users will have a grace
                period of 15 (fifteen) days to renew their subscription. If the
                Account remains unpaid beyond this period, it will be suspended.
                Consequently, all information and data collected on Kalp Studio
                will be deleted no later than 30 (thirty) days from the
                commencement of non-payment
              </span>
            </div>
          </div>
          <div className='description-container'>
            <span className='description-title'>
              5. USER REPRESENTATIONS AND WARRANTIES
            </span>
            <p className='bold-text'>
              By acting as a user, you make the following representations and
              warranties:
            </p>
            <div className='sub-description-container'>
              <span className='sub-description-number'>5.1</span>
              <span className='sub-description'>
                Compliance with Applicable Laws: When utilizing the Site or
                Services, user must adhere to all relevant laws, including, but
                not limited to, those pertaining to the safeguarding of personally
                identifiable information and other regulations related to the
                protection of customer data
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>5.2</span>
              <span className='sub-description'>
                Accuracy of Information: You assure that all information provided
                about the code, including their description, and associated
                documents, is accurate and not misleading.
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>5.3</span>
              <span className='sub-description'>
                Indemnification: You agree to indemnify and hold the Company
                harmless from any claims, losses, or damages arising out of your
                breach of these obligations and representations.
              </span>
            </div>
          </div>
          <div className='description-container'>
            <span className='description-title'>6. USER CONDUCT</span>
            <div className='sub-description-container'>
              <span className='sub-description-number'>6.1</span>
              <span className='sub-description'>
                Unless specified otherwise, we offer you access to the Kalp Studio
                solely for your personal and non-commercial uses. You agree to
                access or use the Kalp Studio only for legal purposes that are
                permitted by these Kalp Studio Terms. To protect our community and
                comply with legal obligations, we reserve the right to take
                action, with or without advance notice, if we believe you have
                violated the Platform Terms. This may include: terminating your
                Account on the Kalp Studio; limiting or disabling your access to
                the Kalp Studio and/or its services; disabling your ability to use
                the Kalp Studio and/or services in conjunction with transacting
                through Kalp Studio; removing your ability to onboard on the Kalp
                Studio or use our services to interact with the Company.
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>6.2</span>
              <span className='sub-description'>
                As a Registered User, you undertake that all the information
                provided by you during the On-Boarding KYC Process was true and
                accurate and that there has been no unreported change in such
                details till date.
              </span>
            </div>
            <div className='sub-description-container column'>
              <div>
                <span className='sub-description-number'>6.3</span>
                <span className='sub-description'>
                  As a user of the Kalp Studio, you agree to uphold all relevant
                  laws, contractual obligations, and the rights of third parties.
                  You are prohibited from:
                </span>
              </div>
              <div className='key-value-container'>
                <div className='key-value'>
                  <span className='roman-number'>(i)</span>
                  <span className='text'>
                    Engaging in any activities that may harm, disable, overburden,
                    or disrupt the normal functioning of the Kalp Studio, or
                    impede the enjoyment of other users.
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(ii)</span>
                  <span className='text'>
                    Attempting to obtain materials or information through
                    unauthorized means that are not made explicitly accessible by
                    the Company through the Kalp Studio.
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(iii)</span>
                  <span className='text'>
                    Promoting your own professional services, particularly if you
                    are associated with real estate agencies, brokers,
                    salespersons, or other professional entities, without proper
                    authorization.
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(iv)</span>
                  <span className='text'>
                    Inappropriately accessing, collecting, storing, disclosing,
                    transferring, or using any information acquired or derived
                    from a user&apos;s access to or use of the Kalp Studio without
                    explicit consent or authorization.
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(v)</span>
                  <span className='text'>
                    Disseminating software or interacting with any Application
                    Programming Interface (API) in a manner that could potentially
                    harm, disable, overburden, or impair the regular operation of
                    the Kalp Studio.
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(vi)</span>
                  <span className='text'>
                    Attempting to reverse engineer, duplicate, decompile,
                    disassemble, decode, or engage in any activity that might lead
                    to the discovery of source code or bypassing measures
                    implemented to prevent or restrict access to any Kalp Studio
                    service, section, or code.
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(vii)</span>
                  <span className='text'>
                    Engaging in any form of fraudulent or deceptive activity on
                    the Kalp Studio, including but not limited to manipulating
                    prices, engaging in scams, or misrepresenting information.
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(viii)</span>
                  <span className='text'>
                    Violating the privacy rights of other users or disclosing
                    their personal information without their explicit consent.
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(x)</span>
                  <span className='text'>
                    Creating, distributing, or promoting content that is illegal,
                    defamatory, threatening, harassing, hateful, discriminatory,
                    or otherwise offensive or harmful.
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(xi)</span>
                  <span className='text'>
                    Using the Kalp Studio for any illegal or unauthorized purpose,
                    including activities related to money laundering, terrorist
                    financing, or other illicit financial practices.
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(xii)</span>
                  <span className='text'>
                    Encouraging or facilitating any activity that violates the
                    Kalp Studio’s Terms or any applicable laws.
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(xiii)</span>
                  <span className='text'>
                    Engaging in any form of unauthorized advertising or spamming
                    on the Kalp Studio.
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(xiv)</span>
                  <span className='text'>
                    Violating any policies, guidelines, or rules established by
                    the Kalp Studio that are communicated to you through the
                    platform or through official channels.
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(xv)</span>
                  <span className='text'>
                    Evading or attempting to evade any restrictions or limitations
                    imposed by the Kalp Studio on your account or usage, including
                    but not limited to creating multiple accounts without proper
                    authorization.
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className='description-container'>
            <span className='description-title'>7. THIRD PARTY SERVICES</span>
            <div className='sub-description-container'>
              <span className='sub-description-number'>7.1</span>
              <span className='sub-description'>
                Certain services on the Kalp Studio may display, include or make
                available content, data, information, applications, or materials
                from third parties (&apos;Third Party Materials&apos;) or provide
                links to certain third-party websites. By using Kalp Studio, you
                acknowledge and agree that the Company is not responsible for
                examining or evaluating the content, accuracy, completeness,
                timeliness, validity, copyright compliance, legality, decency,
                quality or any other aspect of such Third-Party Materials or
                websites
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>7.2</span>
              <span className='sub-description'>
                Company and its officers, affiliates, and subsidiaries do not
                warrant or endorse and do not assume and will not have any
                liability or responsibility to you or any other person for any
                third-party services, Third party Materials or websites, or for
                any other materials, products, or services of third parties. Third
                Party Materials and links to other websites are provided solely as
                a convenience to you. The use of such third-party services shall
                be strictly in accordance with the respective terms and conditions
                of such third parties.
              </span>
            </div>
          </div>
          <div className='description-container'>
            <span className='description-title'>
              8. INTELLECTUAL PROPERTY RIGHTS
            </span>
            <div className='sub-description-container'>
              <span className='sub-description-number'>8.1</span>
              <span className='sub-description'>
                Unless otherwise stated by the Company, the Site, all content, and
                other materials contained therein, including, without limitation,
                the Company’s logo, and all designs, text graphics, pictures,
                information, data, software, and files relating to the Kalp Studio
                (“Our Content”) are the proprietary property of the Company or our
                affiliates, licensors, or users, as applicable.
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>8.2</span>
              <span className='sub-description'>
                The Company logo and any Kalp Studio product or service names,
                logos, or slogans that may appear on the Site or elsewhere are the
                proprietary property of the Company and may not be copied,
                imitated or used, in whole or in part, without our prior written
                permission. Unless otherwise stated, you may not use any Our
                Content without our express written permission.
              </span>
            </div>
          </div>
          <div className='description-container'>
            <span className='description-title'>9. COMPLAINTS TO THE GRC</span>
            <p className='normal-text'>
              We, as a Company, recognize the paramount importance of establishing
              an effective and fair dispute resolution mechanism. To this end, we
              have instituted a Grievance Redressal Committee (GRC) dedicated to
              addressing and adjudicating on complaints and feedback from our
              valued users. If, at any point, you believe that a Kalp Studio is in
              violation of any conditions outlined in these Platform Terms, we
              encourage you to promptly submit a complaint to the GRC, providing
              all pertinent facts, supporting evidence, relevant documents, and
              any other materials necessary to facilitate a comprehensive review.
              Such complaints should be submitted via email to the address
              specified at grievance@kalp.studio
            </p>
            <div className='sub-description-container'>
              <span className='sub-description-number'>9.1</span>
              <span className='sub-description'>
                Investigation and Response: Following the receipt of a complaint,
                the GRC will initiate an investigation into the alleged violation.
                In the interest of fairness and transparency, the GRC will also
                extend an opportunity to the user to provide a response or
                explanation in connection with the allegations.
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>9.2</span>
              <span className='sub-description'>
                Adjudication and Remedial Action: Upon careful and impartial
                review, the GRC will issue a final order. If, in the opinion of
                the GRC, the alleged violation is substantiated and found to be in
                contravention of these Platform Terms, we expressly reserve the
                right to take appropriate remedial actions.
              </span>
            </div>
            <div className='sub-description-container column'>
              <div>
                <span className='sub-description-number'>9.3</span>
                <span className='sub-description'>
                  Remedial Actions: Remedial actions may include, but are not
                  limited to, any or all of the following:
                </span>
              </div>
              <div className='key-value-container'>
                <div className='key-value'>
                  <span className='roman-number'>(i)</span>
                  <span className='text'> Issuing warnings to the users</span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(ii)</span>
                  <span className='text'>
                    Temporarily or permanently suspending the access from the Kalp
                    Studio.
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(iii)</span>
                  <span className='text'>
                    Any other measures deemed necessary by the GRC to address the
                    violation and uphold the integrity of the Kalp Studio
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className='description-container'>
            <span className='description-title'>10. ASSUMPTIONS OF RISK</span>
            <div className='sub-description-container column'>
              <div>
                <span className='sub-description-number'>10.1</span>
                <span className='sub-description'>
                  General Assumptions of Risk:{" "}
                </span>
              </div>
              <div className='key-value-container'>
                <div className='key-value'>
                  <span className='roman-number'>(i)</span>
                  <span className='text'>
                    The Company will not be liable for any loss of any kind from
                    any action taken or taken in reliance on material or
                    information contained on the Kalp Studio. The Company does not
                    represent or warrant that any content on the Kalp Studio is
                    accurate, complete, reliable, current or error-free.
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(ii)</span>
                  <span className='text'>
                    The user acknowledges and agrees that hosting data online
                    carries inherent risks of unauthorized disclosure or exposure.
                    By accessing and utilizing the Services, the Customer accepts
                    these risks. The Company makes no representation, warranty, or
                    guarantee that user data will remain undisclosed or secure
                    against exposure due to errors or actions by third parties.
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(iii)</span>
                  <span className='text'>
                    The Company makes no warranty that the services provided
                    through the Kalp Studio will meet your requirements, or that
                    the Kalp Studio will be uninterrupted, timely, secure, or
                    error free. This includes loss of data or any service
                    interruption caused due to any reason whatsoever. The Company
                    is not responsible for transmission errors, corruption of
                    data.
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(iv)</span>
                  <span className='text'>
                    Under no circumstances, the operation of all or any portion of
                    the Kalp Studio will be deemed to create a relationship that
                    includes the provision or tendering of an investment advice.
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(v)</span>
                  <span className='text'>
                    The Company shall act within the bounds of the applicable
                    laws. The Company endeavours to abide by the AML and CTF
                    standards set by the FATF and hence, may report the suspicious
                    financial transactions done by you on the Kalp Studio to the
                    appropriate authorities.
                  </span>
                </div>
              </div>
            </div>
            <div className='sub-description-container column'>
              <div>
                <span className='sub-description-number'>10.2</span>
                <span className='sub-description'>
                  Risks of Smart Contracts and Blockchain technology
                </span>
              </div>
              <div className='key-value-container'>
                <div className='key-value'>
                  <span className='roman-number'>(i)</span>
                  <span className='text'>
                    The user represents and warrants that the user is
                    knowledgeable, experienced and understands the usage of
                    blockchain technology and that user acknowledges, understands
                    and is willing to accept the risks associated with related
                    technological and cryptographic systems such as blockchains,
                    smart contracts, decentralized or peer-to-peer networks and
                    systems etc
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(ii)</span>
                  <span className='text'>
                    The user further acknowledge and agree that such technological
                    systems (inclusive of the examples listed in the preceding
                    sentence) may be subject to malfunctions, bugs, timing errors,
                    hacking and theft, changes to the protocol rules of the
                    blockchain (i.e., ‘forks’), hardware, software and/or Internet
                    connectivity failures, unauthorized third party data access,
                    and other technological risks, any of which can adversely
                    affect the relevant smart contracts and may expose user to a
                    risk of loss.
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(iii)</span>
                  <span className='text'>
                    The user accepts the inherent security risks of providing
                    information and conducting business over the Internet and
                    acknowledge that Company assumes no liability or
                    responsibility for any such failures, risks, or uncertainties,
                    nor for any communication failures, disruptions, errors,
                    distortions or delays that the user may experience when using
                    the Kalp Studio, however so caused
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(iv)</span>
                  <span className='text'>
                    The Kalp Studio may experience or be the target of
                    sophisticated cyber-attacks, unexpected surges in activity or
                    other operational or technical difficulties that may cause
                    interruptions to or delays on the platform
                  </span>
                </div>
                <div className='key-value'>
                  <span className='roman-number'>(v)</span>
                  <span className='text'>
                    The user acknowledges that the smart contracts once executed
                    over the blockchain are permanent and immutable and there
                    shall be no cancellation or refund of any transaction that has
                    once been executed through the smart contract.
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className='description-container'>
            <span className='description-title'>
              11. AMENDMENT TO THIS POLICY
            </span>
            <p className='normal-text'>
              Any changes to be made to these Platform Terms will be effective
              once published on the website or upon release to the users of Kalp
              Studio. Your continued use of the Kalp Studio or the Services
              available therein is considered your acceptance of such amended
              terms. If you do not agree to any amendments in these Platform
              Terms, you must stop using the Kalp Studio effective immediately. A
              frequent viewing of these Platform Terms is recommended for a better
              understanding of the Platform Terms that apply to access and use of
              the Kalp Studio.
            </p>
          </div>
          <div className='description-container'>
            <span className='description-title'>12.PROHIBITION OF US</span>
            <p className='normal-text'>
              UPON THE ACCESS AND USE OF THE KALP STUDIO, YOU REPRESENT AND
              CONFIRM THAT YOU ARE NOT A PART OF ANY TRADE EMBARGOES OR ECONOMIC
              SANCTIONS LIST (SUCH AS THE UNITED NATIONS SECURITY COUNCIL
              SANCTIONS LIST), ETC. RESERVES THE RIGHT TO DECIDE MARKETS AND
              JURISDICTIONS TO CONDUCT BUSINESS, AND MAY RESTRICT OR PROHIBIT, AS
              PER DISCRETION, THE USE OF THE KALP STUDIO IN CERTAIN COUNTRIES OR
              REGIONS
            </p>
          </div>
          <div className='description-container'>
            <span className='description-title'>13.DISCLAIMER</span>
            <div className='sub-description-container'>
              <span className='sub-description-number'>13.1</span>
              <span className='sub-description'>
                THIS KALP STUDIO IS PROVIDED BY THE COMPANY ON AN “AS IS” AND “AS
                AVAILABLE” BASIS AND THE COMPANY MAKES NO REPRESENTATIONS OR
                WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE OPERATION OF
                THIS KALP STUDIO OR THE INFORMATION, CONTENT INCLUDED ON THIS KALP
                STUDIO. YOU EXPRESSLY AGREE THAT YOUR USE OF THIS KALP STUDIO IS
                AT YOUR SOLE RISK. THE COMPANY RESERVES THE RIGHT TO WITHDRAW OR
                DELETE ANY INFORMATION FROM THIS KALP STUDIO AT ANY TIME IN ITS
                DISCRETION.{" "}
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>13.2</span>
              <span className='sub-description'>
                YOU AGREE THAT YOUR USE OF THE KALP STUDIO SHALL BE AT YOUR SOLE
                RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, THE COMPANY, ITS
                OFFICERS, DIRECTORS, EMPLOYEES, AND AGENTS EXCLUDE ALL WARRANTIES,
                EXPRESS OR IMPLIED, IN CONNECTION WITH THE KALP STUDIO AND YOUR
                USE THEREOF
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>13.3</span>
              <span className='sub-description'>
                WE HAVE EXERTED REASONABLE EFFORTS TO ENSURE THAT ALL INFORMATION
                PUBLISHED ON THE KALP STUDIO IS ACCURATE AT THE TIME OF POSTING;
                HOWEVER, THERE MAY BE ERRORS IN SUCH INFORMATION FOR WHICH WE
                SHALL HAVE NO LIABILITY. WE RESERVE THE RIGHT TO REMOVE OR ALTER
                ANY OF THE INFORMATION CONTAINED ON THE KALP STUDIO AT OUR SOLE
                DISCRETION.
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>13.4</span>
              <span className='sub-description'>
                WE SHALL MAKE BEST ENDEAVOURS TO ENSURE THAT THE SERVICES PROVIDED
                ON THE KALP STUDIO ARE ERROR-FREE AND SECURE, HOWEVER, NEITHER THE
                COMPANY NOR ANY OF ITS PARTNERS, LICENSORS OR ASSOCIATES MAKES ANY
                WARRANTY THAT (I) THE KALP STUDIO WILL MEET USERS&apos;
                REQUIREMENTS; (II) KALP STUDIO WILL BE UNINTERRUPTED, TIMELY,
                SECURE, OR ERROR FREE; (III) THE QUALITY OF THE KALP STUDIO,
                INFORMATION, OR OTHER MATERIAL THAT USERS OBTAIN THROUGH THE KALP
                STUDIO WILL MEET USERS&apos; EXPECTATIONS.
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>13.5</span>
              <span className='sub-description'>
                TO THE EXTENT PERMITTED BY LAW, THE COMPANY SHALL NOT BE
                RESPONSIBLE FOR LOST PROFITS, REVENUES, OR DATA, FINANCIAL LOSSES
                OR INDIRECT, SPECIAL, CONSEQUENTIAL, EXEMPLARY, OR PUNITIVE
                DAMAGES, WHETHER ARISING FROM OR RELATING TO THESE PLATFORM TERMS,
                THE KALP STUDIO, OUR CONTENT OR THIRD-PARTY MATERIALS, OR FOR ANY
                DAMAGES RELATED TO LOSS OF REVENUE, LOSS OF PROFITS, LOSS OF
                BUSINESS OR ANTICIPATED SAVINGS, LOSS OF USE, LOSS OF GOODWILL, OR
                LOSS OF DATA, AND WHETHER CAUSED BY TORT (INCLUDING NEGLIGENCE),
                BREACH OF CONTRACT, OR OTHERWISE, EVEN IF FORESEEABLE AND EVEN IF
                THE COMPANY HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>13.6</span>
              <span className='sub-description'>
                TO THE FULLEST EXTENT PERMISSIBLE BY LAW AND NOTWITHSTANDING
                ANYTHING TO THE CONTRARY CONTAINED IN THESE PLATFORM TERMS, IN NO
                EVENT SHALL THE MAXIMUM AGGREGATE LIABILITY OF THE COMPANY EXCEED
                USD 10,000
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>13.7</span>
              <span className='sub-description'>
                YOUR USE OF THE KALP STUDIO AND/OR ANY TRANSACTION OF ANY SERVICES
                DOES NOT CONSTITUTE ANY FORM OF
                PARTNERSHIP/VENTURE/INVESTMENT/VOTING SHARE/COLLECTIVE
                INVESTMENT/FINANCIAL ASSISTANCE OR ANY OTHER COLLOBORATION BETWEEN
                YOU AND US. BUYING A SERVICES DOESN’T ENTITLE YOU TO ANY RIGHTS IN
                THE KALP STUDIO AND THE COMPANY OR ANY OF ITS ASSETS
              </span>
            </div>
          </div>
          <div className='description-container'>
            <span className='description-title'>14.COMPLIANCE</span>
            <div className='sub-description-container'>
              <span className='sub-description-number'>14.1</span>
              <span className='sub-description'>
                You are responsible solely for making sure that your use of the
                Kalp Studio is compliant with all laws, rules and regulations
                applicable to you
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>14.2</span>
              <span className='sub-description'>
                Your right to access the services is automatically revoked where
                its use is prohibited or to the extent that the offering of the
                services on the Kalp Studio violates any law, rule or provision
                applicable to you.
              </span>
            </div>
          </div>
          <div className='description-container'>
            <span className='description-title'>15.LICENSE</span>
            <p className='normal-text'>
              Subject to compliance with these Platform Terms and the applicable
              laws, the Company grants you a non-transferable, nonexclusive,
              revocable and limited license to use and access the Kalp Studio for
              your personal purposes. This license is given explicitly for you to
              use the Services provided on the Kalp Studio and the other platforms
              of the Company. The Company shall revoke this license if there is
              any unauthorized use of the license.
            </p>
          </div>
          <div className='description-container'>
            <span className='description-title'>16.PRIVACY POLICY</span>

            <div className='sub-description-container'>
              <span className='sub-description-number'>16.1</span>
              <span className='sub-description'>
                We respect the privacy of every individual and endeavor to
                establish best practices while processing personal data which is
                collected, transferred, collated, accesses by us.
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>16.2</span>
              <span className='sub-description'>
                At the time of your registration/sign-up and during your use of
                our Platform, we collect data, information which may be personal
                or sensitive personal data. The information is processed according
                to the category of data and in compliance with the applicable data
                privacy laws.
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>5.3</span>
              <span className='sub-description'>
                Indemnification: You agree to indemnify and hold the Company
                harmless from any claims, losses, or damages arising out of your
                breach of these obligations and representations.
              </span>
            </div>
          </div>
          <div className='description-container'>
            <span className='description-title'>17.MODIFICATION</span>
            <p className='normal-text'>
              The Company reserves the right at any time to change, suspend, or
              discontinue the Kalp Studio in whole or in part with or without
              notice to the users. You agree that the Company will not be liable
              to you for any such act.
            </p>
          </div>
          <div className='description-container'>
            <span className='description-title'>18.TAX COMPLIANCE</span>
            <p className='normal-text'>
              You agree that you are solely liable for determining what, if any,
              taxes apply to your transactions on the Kalp Studio, as per the
              applicable laws of any country in which you are residing or are
              situated. Neither the Company nor any other Third Party is
              responsible for determining the taxes that may apply to your
              transactions on any platform or service offered by the Company.
            </p>
          </div>

          <div className='description-container'>
            <span className='description-title'>19.INDEMNIFICATION</span>
            <p className='normal-text'>
              You agree to indemnify, defend, and hold harmless the Company, its
              affiliates, officers, directors, employees, agents, partners, and
              licensors from and against any and all claims, liabilities, damages,
              losses, costs, expenses, fees (including reasonable attorneys&apos;
              fees), and judgments arising from or relating to:
            </p>
          </div>
          <div className='description-container'>
            <span className='description-title'>20.ARBITRATION CLAUSE</span>
            <div className='sub-description-container'>
              <span className='sub-description-number'>20.1</span>
              <span className='sub-description'>
                All or any disputes, controversy or claim, arising out or touching
                upon or in relation to the Platform Terms, including the
                interpretations and validity of the terms hereof and respective
                rights and obligations of the Parties, shall be settled amicably
                by mutual discussion, failing which the same shall be settled
                through Arbitration of a sole Arbitrator appointed mutually by the
                Parties. The Arbitration shall be subject to the Arbitration and
                Conciliation Act, 1996 as may be amended from time to time.
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>21.1</span>
              <span className='sub-description'>
                The Seat and Venue of the Arbitration shall be in New Delhi, and
                the arbitration shall be conducted in English language
              </span>
            </div>
          </div>
          <div className='description-container'>
            <span className='description-title'>21. MISCELLANEOUS</span>
            <div className='sub-description-container'>
              <span className='sub-description-number'>21.1</span>
              <span className='sub-description'>
                Waiver: The remedies herein reserved shall be cumulative, and in
                addition to any other remedies provided at law or equity. Any
                failure by the Company to enforce or insist upon strict compliance
                with any provision of these Platform Terms shall not be deemed to
                constitute a waiver of rights to demand strict compliance with the
                terms hereof. No waiver of any term or condition of these Platform
                Terms shall be deemed or construed to be a waiver of any
                subsequent such term or condition in the future.
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>21.2</span>
              <span className='sub-description'>
                Severability: Each of the above restrictions is separate and
                severable from the other. Any provision which is invalid or
                unenforceable, shall be ineffective to the extent of such
                invalidity or unenforceability, without affecting in any way the
                remaining provisions hereof.
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>21.3</span>
              <span className='sub-description'>
                Entire Agreement: These Platform Terms and the terms and
                conditions set out in these Platform Terms by reference,
                constitute the entire agreement between the user and the Company
                with respect to the subject matter hereof.
              </span>
            </div>
            <div className='sub-description-container'>
              <span className='sub-description-number'>21.4</span>
              <div className="row">
                <span className='sub-description'>
                  Notice: Any notice, consent or other communication permitted or
                  required by these Platform Terms, unless otherwise states, is to
                  be given in writing and forwarded by email and/or registered post
                  with acknowledgement due or hand delivery to the following
                  address:
                </span>
                <p className='bold-text ' style={{ color: "#404040" }}>
                  FC -19, Sector 16 A, Gautam Budha Nagar, Uttar Pradesh - 201301
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndCondition;